import 'css-chunksrc/client/pages/exportsPage/wbsReport/sort/styles.scss';export default {
  "sort": "_sort_ilgbw_1",
  "label": "_label_ilgbw_9",
  "input": "_input_ilgbw_15",
  "placeholder": "_placeholder_ilgbw_31",
  "icon": "_icon_ilgbw_39",
  "listRoot": "_listRoot_ilgbw_47",
  "list": "_list_ilgbw_47",
  "item": "_item_ilgbw_63",
  "option": "_option_ilgbw_76",
  "selected": "_selected_ilgbw_83",
  "opened": "_opened_ilgbw_96"
};